import axios from '@dap/shared-utils/http.js';

const typeMap = new Map();
typeMap.set('campaign', 'campaign');
typeMap.set('group', 'adgroup');
typeMap.set('ad', 'ad');

export default {
    // 查询批量表单的设置，目前只有是否走组合推荐
    getBatchRecommendedCheck (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/batch/get_batch_setting', {
            params,
        });
    },
    // // 判断头条批量仅生成推荐组合
    // getRecommendedCheck (params = {}) {
    //     return axios.get('/dapper/api/kuaishou_ad/recommend/check', { params });
    // },
    getAdNameCheck (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/ad/checkname', { params });
    },
    // 创建广告
    postSaveSingleAd (options = {}) {
        return axios.post('/dapper/api/kuaishou_ad/ad/add', options);
    },
    // 获取点击监测链接
    getClickMonitorLink (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/url', { params });
    },
    getKuaishouDict () {
        return axios.get('/dapper/api/kuaishou_ad/dict');
    },
    // 获取快手推荐定向列表
    getRecommendedList (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/recommend/audiences', {
            params,
        });
    },
    // 推荐创意列表
    getRecommendedCreativeList (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/recommend/creatives', {
            params,
        });
    },

    getKuaishouCurrentRecommendAudience (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/recommend/audiences/current', { params });
    },
    //创意列表
    getKuaishouCreativeList (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/creative/list', { params });
    },

    // // 获取自建站列表
    // getSiteList (params = {}) {
    //     return axios.get('/dapper/api/kuaishou_ad/sites', { params });
    // },

    // // 获取定向详情
    // getTargetDetail (params = {}) {
    //     return axios.get('/dapper/api/kuaishou_ad/targeting/detail', {params});
    // },

    // // 新建转化
    // addConvert (params = {}) {
    //     return axios.post('/dapper/api/kuaishou_ad/convert/add', params);
    // },
    // // 定向包接口 （快手）
    // getKuaishouAudiences (params = {}) {
    //     return axios.get('/dapper/api/aud/tt_ad/audiences', { params });
    // },

    getAutoName (type, params = {}) {
        return axios.get(`/dapper/api/kuaishou_ad/${typeMap.get(type)}/auto_name`, { params });
    },

    // 新增/修改 广告计划/广告组/广告
    update (type, params = {}) {
        return axios.post(`/dapper/api/kuaishou_ad/${typeMap.get(type)}/add`, params);
    },

    // 获取详情信息 广告计划/广告组/广告
    getInfo (type, params = {}) {
        return axios.get(`/dapper/api/kuaishou_ad/${typeMap.get(type)}/edit`, {
            params,
        });
    },

    // 层级搜索 广告计划/广告组
    searchCampaignGroup (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/search', { params });
    },

    // 查询广告组人数预估
    getEstimation (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/estimation', { params });
    },

    // // 获取广告组安卓分包
    // getAosInfo (params = {}) {
    //     return axios.get('/dapper/api/kuaishou_ad/adgroup/aos', { params });
    // },

    getBatchPreviewList (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/batch/list', { params });
    },

    // updateAdgroup (params = {}) {
    //     return axios.post('/dapper/api/kuaishou_ad/batch/batch_adgroup', params);
    // },

    getAdgroupCreativePreView (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/batch/adgroup_creative_preview', { params });
    },

    getBatchCreativePreView (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/batch/batch_creative_preview', { params });
    },

    postBatchData (params = {}) {
        return axios.post('/dapper/api/kuaishou_ad/batch/create', params);
    },

    getBatchCommitBatch (params = {}) {
        return axios.post('/dapper/api/kuaishou_ad/batch/commit', params);
    },

    // 预览页字段编辑
    batchPageEdit (params = {}) {
        return axios.post('/dapper/api/kuaishou_ad/batch/edit', params);
    },

    // // 保存本次创建， (草稿接口，添加自定义字段)
    createLastData (params = {}) {
        return axios.post('/dapper/api/kuaishou_ad/batch/create_last', params);
    },

    // // 获取上次创建内容， (草稿接口，返回自定义字段)
    getLastData (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/batch/fetch_latest', {
            params,
        });
    },

    checkKuaishouName (type, params = {}) {
        return axios.get(`/dapper/api/kuaishou_ad/${typeMap.get(type)}/checkname`, { params });
    },

    getAdCopyOrPushBatchId (type, params = {}) {
        return axios.post(`/dapper/api/kuaishou_ad2/duplicate/create_batch_from_${typeMap.get(type)}`, params);
    },

    getAdCopyOrPushList (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad2/duplicate/duplicate_batch_list', { params });
    },

    // getCommon (params = {}) {
    //     return axios.get('/dapper/api/ad/common', { params });
    // },

    getAdDetailData (type, params = {}) {
        return axios.get(`/dapper/api/kuaishou_ad2/duplicate/get_${typeMap.get(type)}_detail`, { params });
    },

    saveCopyOrPushData (type, params = {}) {
        return axios.post(`/dapper/api/kuaishou_ad2/duplicate/save_${typeMap.get(type)}_detail`, params);
    },

    commitCopyOrPush (params = {}) {
        return axios.post('/dapper/api/kuaishou_ad2/duplicate/commit_duplicate_batch', params);
    },

    // 获取列表数据 广告计划/广告组/广告
    getKuaishouTableList (type, params = {}) {
        return axios.get(`/dapper/api/kuaishou_ad/${typeMap.get(type)}`, {
            params,
        });
    },

    // getBatchDetailData (params = {}) {
    //     return axios.get('/dapper/api/kuaishou_ad/batch/get_batch_detail', { params } );
    // },

    // getThirtyLandingData (params = {}) {
    //     return axios.get('/dapper/api/kuaishou_ad/sites', { params } );
    // },

    // getDouyinUsers (params = {}) {
    //     return axios.get('/dapper/api/kuaishou_ad/ies_account', { params } );
    // },

    // getActionTexts (params = {}) {
    //     return axios.get('/dapper/api/kuaishou_ad/action_text', { params } );
    // },

    // getClueConverts (params = {}) {
    //     return axios.get('/dapper/api/kuaishou_ad/site_convert', { params } );
    // },

    // getAssembleCreativeList (params = {}) {
    //     return axios.get('/dapper/api/creative', { params } );
    // },

    // getPlayableUrlList (params = {}) {
    //     return axios.get('/dapper/api/kuaishou_ad/playable_urls', { params } );
    // },

    checkCampaignNameRepeated (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad2/campaigns/check', {
            params,
        });
    },
    // 广告计划列表上的编辑
    editCampaignConstraint (params = {}) {
        return axios.put('/dapper/api/kuaishou_ad2/campaign/edit', params);
    },
    // checkGroupNameRepeated (params = {}) {
    //     return axios.get('/dapper/api/kuaishou_ad2/adgroups/check', { params });
    // },

    // checkAdNamesRepeated (params = {}) {
    //     return axios.get('/dapper/api/kuaishou_ad2/ads/check', { params });
    // },

    // 获取投放原生达人（快手号）
    getKuaiShouUser (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/native/users', { params });
    },
    // 获取快手创意
    getKuaiNativePhotos (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/native/photos', { params });
    },
    // 批量草稿校验
    postBatchCreateValid (params = {}) {
        return axios.post('/dapper/api/kuaishou_ad/batch/create/valid', params);
    },

    // 获取默认账号
    getDefaultAccount (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/default_account', { params });
    },

    // 获取魔力战链接
    getKuaishouPage (params = {}) {
        return axios.get('/dapper/api/kuaishou_ad/pages', { params });
    },
};
